
import React, { Component } from 'react';
import PickerToolbar from "@material-ui/pickers/_shared/PickerToolbar";
//import ToolbarButton from "@material-ui/pickers/_shared/ToolbarButton";
import { withStyles } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import {colores} from '../global';


const styles = theme=> ({
	toolbar: {
		display: "flex",
		flexDirection: "row",
        alignItems: "flex-start",
        maxHeight: '35px',
        minHeight: '35px',
        background: '#FFFFFF', //theme.palette.primary,  
        padding: 0
    },
});

const monthNames = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
  "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
];

const colorOption = undefined;
const colorOptionSelected = '#FFFFFF';

export default withStyles(styles)(
class CustomToolbar extends Component {  

render() {
        
        const { date,
            isLandscape,
            openView,
            setOpenView,
            classes,
            title} = this.props;

            
const handleChangeViewClick = (view) => (e) => {
    setOpenView(view);        
}

return (
		<PickerToolbar className={classes.toolbar} title={title} isLandscape={isLandscape}>           
            <Button
                onClick={handleChangeViewClick("date")}
                style={{ marginTop: 3, textTransform: 'none', color: openView === "date" ? colorOptionSelected : colorOption, background: openView === "date" ? colores.azul : undefined }}
                variant="text"
            >
            {monthNames[date.getMonth()] + ' ' + date.getDate().toString().padStart(2, '0')}
            </Button>
            <Button
                onClick={handleChangeViewClick("year")}
                style={{ marginTop: 3, color: openView === "year" ? colorOptionSelected : colorOption, background: openView === "year" ? colores.azul : undefined }}
                variant="text"
            >
            {date.getFullYear().toString()}
            </Button>    
		</PickerToolbar>
    );
    
    }

}
);
